import { zSidLabel } from "src/types/ZSidLabel";
import z from "zod";

export const zValueCatalogRef = z.string().describe("Каталог значений");

export const zOptionsInline = z.object({
  type: z.literal("inline"),
  list: zSidLabel.array(),
});

const zOptionsValuesCatalog = z.object({
  type: z.literal("valuesCatalog"),
  valuesCatalogId: zValueCatalogRef,
  labelTemplate: z.string().describe("Шаблон для формирования наименований"),
});
export type ZOptionsValuesCatalog = z.infer<typeof zOptionsValuesCatalog>;

export const zOptionsMaker = z.discriminatedUnion("type", [
  zOptionsInline,
  zOptionsValuesCatalog,
]);
export type ZOptionsMaker = z.infer<typeof zOptionsMaker>;
